// NOTE: most of this code is inspired or from [typesafe-actions](https://github.com/piotrwitek/typesafe-actions)
// We couldn't use it directly because of it's use of Object.assign, which isn't
// supported on IE11 (and which we probably can't reliably polyfill).

/**
 * @module
 *
 * WARNING * WARNING * WARNING
 *
 * NOTICE: this dispatch pattern is being deprecated and should NOT BE COPIED.
 *
 * tracking: https://gitlab.sas.com/dvr/html/react-commons/issues/250
 *
 * If you have a use case, please leave a comment on the issue.
 */

/**
 * Creates a standard action that is compatible with FSA.
 * @see https://github.com/redux-utilities/flux-standard-action
 *
 * @param type The action type (should probably be a literal type)
 */
export function action(type, payload, meta) {
  return {
    type,
    payload,
    meta
  };
}

// NOTE: this Action type could be shorter with intersections, but the intersections don't
//     | seem to distribute at the moment (typescript 3.2.2)
// prettier-ignore
/**
 * A standard action that is compatible with FSA.
 * @see https://github.com/redux-utilities/flux-standard-action
 */
/**
 * A bottom type for all actions. Should be the same type that redux uses.
 *
 * TODO: do we want to include redux types in another module for this purpose?
 */
// prettier-ignore
/**
 * Infers Action union-type from an object of action creators (and nested
 * objects of action creators).
 *
 * @example
 * const actionCreators = {
 *   a: () => action('type1'),
 *   b: () => action('type2', { data: 5 }),
 *   c: () => action('type2', { data: 6 }),
 * };
 * // { type: 'type1' } | { type: 'type2', payload: { data: number } }
 * type MyActions = ActionType<typeof actionCreators>;
 *
 * @example
 * // the module should export action creators and/or nested action creator objects
 * import * as actionCreators from './my-action-creators';
 * type MyActions = ActionType<typeof actionCreators>;
 */
//# sourceMappingURL=action.js.map